export var Method;
(function (Method) {
    Method[Method["GET"] = "GET"] = "GET";
    Method[Method["POST"] = "POST"] = "POST";
    Method[Method["PUT"] = "PUT"] = "PUT";
    Method[Method["DELETE"] = "DELETE"] = "DELETE";
    Method[Method["PATCH"] = "PATCH"] = "PATCH";
    Method[Method["OPTIONS"] = "OPTIONS"] = "OPTIONS";
})(Method || (Method = {}));
export class HttpRequest {
    /**
     * @param path
     */
    constructor(path) {
        this.path = path;
        /**
         * @type {number}
         */
        this.timeoutValue = 30000;
        /**
         * @type {Method}
         */
        this.method = Method.GET;
        /**
         * @type {{}}
         */
        this.queryParams = {};
        /**
         * @type {{}}
         */
        this.headerParams = {};
        /**
         * @type {{}}
         */
        this.bodyParams = null;
    }
    /**
     * @returns {string}
     */
    getPath() {
        return this.path;
    }
    /**
     * @returns {Method}
     */
    getMethod() {
        return this.method;
    }
    /**
     * @returns {number}
     */
    getTimeout() {
        return this.timeoutValue;
    }
    /**
     * @returns {Blob|FormData|string}
     */
    getBodyParams() {
        return this.bodyParams;
    }
    /**
     * @returns {Object}
     */
    getHeaderParams() {
        return this.headerParams;
    }
    /**
     * @returns {Object}
     */
    getQueryParams() {
        return this.queryParams;
    }
    /**
     * @param url
     * @returns {HttpRequest}
     */
    url(url) {
        const request = Object.assign(Object.create(this), this);
        request.path = url;
        return request;
    }
    /**
     * @param timeout
     * @returns {HttpRequest}
     */
    timeout(timeout) {
        const request = Object.assign(Object.create(this), this);
        request.timeoutValue = timeout;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    post() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.POST;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    get() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.GET;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    patch() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.PATCH;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    put() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.PUT;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    delete() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.DELETE;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    options() {
        const request = Object.assign(Object.create(this), this);
        request.method = Method.OPTIONS;
        return request;
    }
    /**
     * @param key
     * @param value
     * @returns {HttpRequest}
     */
    query(key, value) {
        const request = Object.assign(Object.create(this), this);
        request.queryParams[key] = value;
        return request;
    }
    /**
     * @param key
     * @param value
     * @returns {HttpRequest}
     */
    header(key, value) {
        const request = Object.assign(Object.create(this), this);
        request.headerParams[key] = value;
        return request;
    }
    /**
     * @returns {HttpRequest}
     */
    jsonHeaders() {
        return this.header('Content-Type', 'application/json');
    }
    /**
     * @param value
     * @returns {HttpRequest}
     */
    body(value) {
        const request = Object.assign(Object.create(this), this);
        request.bodyParams = value;
        return request;
    }
}
